'use client';

import {SKZMatch, SKZTournament, SKZMatchPlayer} from '@sdk-mobile';
import {ISdkMatch, ISdkPlayer} from '@/services/internal/match/interfaces';

export const GAME_IFRAME_ID = 'game-iframe';

const getGameFrame = () => document.querySelector(`#${GAME_IFRAME_ID}`) as HTMLIFrameElement | null;

export const getGameOrigin = () => {
  const frame = getGameFrame();
  return frame ? new URL(frame.src).origin : null;
};

export const sendMessageToGame = (
  topic: string,
  payload?: Record<string, any> | string,
  error?: string
) => {
  const frame = getGameFrame();
  const origin = getGameOrigin();

  if (!frame || !origin) {
    return;
  }

  const message = {
    topic,
    payload,
    error,
  };

  return frame.contentWindow?.postMessage(message, origin);
};

// https://docs.skillz.com/docs/api-reference/#match
export interface SdkMatch {
  // Todo redfine when working on sync match joins
  connectionInfo?: Record<string, string>;
  matchDescription: string;
  entryCash: number;
  entryPoints: number;
  id: number;
  playerMatchId?: number;
  templateId: number;
  name: string;
  gameParameters: Record<string, string>;
  isCash: boolean;
  isSynchronous: boolean;
  isTieBreaker: boolean;
  isBracket: boolean;
  bracketRound: number;
  isVideoAdEntry: boolean;
  players: Array<ISdkPlayer>;
}

export const shapeMatchForGame = (
  match: SKZMatch,
  tournament: SKZTournament,
  userId: string
): ISdkMatch => {
  const playerMatchId = match.players.find((p) => p.user_id === Number(userId))?.id || 0;
  console.log('SCORESEC: shapeMatchForGame: match', match, 'tournament', tournament);
  return {
    matchDescription: tournament.description,
    entryCash: tournament.cash_fee,
    isCash: tournament.cash_fee !== 0,
    name: match.name,
    entryPoints: tournament.z_fee,
    isSynchronous: tournament.synchronous,
    id: match.id,
    templateId: tournament.id,
    bracketRound: 0,
    playerMatchId,
    isBracket: !!match.bracket,
    isTieBreaker: match.tie_breaker,
    isVideoAdEntry: false,
    gameParameters: Object.fromEntries(match.rules.map((rule) => [rule.name, rule.value])),
    players: match.players.map((player: SKZMatchPlayer) => ({
      id: player.user_id,
      displayName: player.name,
      avatarURL: player.avatar_url,
      isCurrentPlayer: player.user_id === Number(userId),
      playerMatchId: Number(player.id),
      flagURL: player.flag_url,
    })),
  };
};
